import React, { FC } from 'react';
import map from 'assets/img/icons/ic-map.svg';
import i18next from 'i18next';
import { Box, Typography } from '@material-ui/core';
import { useStyles } from './styles';

interface Props {
    title: string;
    hour?: string;
    timeZone?: string;
    upcoming?: boolean;
}

const EventName: FC<Props> = ({ timeZone, title, hour, upcoming }) => {
    const classes = useStyles();

    return (
        <Box>
            <Typography variant="h1" className={classes.title}>
                {title}
            </Typography>

            <Box className={classes.eventTime}>
                <img src={map} alt="map" className={classes.eventTimeIcon} />
                <Typography className={classes.eventTimeText}>
                    {i18next.t(
                        upcoming ? 'CategoryNameFechaComponentLiveAt' : 'CategoryNameFechaComponentPlayedAt',
                    )}{' '}
                    {hour} {timeZone}
                </Typography>
            </Box>
        </Box>
    );
};

export default EventName;
